var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      style: _vm.removeWhenPivotCompletelyInVue,
      attrs: { role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          style: _vm.removeWhenPivotCompletelyInVue2,
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("pivotCreateTemplate")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "pivotName" } }, [
                  _vm._v(_vm._s(_vm.$t("pivotTemplateName")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "pivotName" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.name = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group form-check pl-0" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shared,
                      expression: "shared"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "pivotShared" },
                  domProps: {
                    checked: Array.isArray(_vm.shared)
                      ? _vm._i(_vm.shared, null) > -1
                      : _vm.shared
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.shared,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.shared = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.shared = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.shared = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label ml-4",
                    attrs: { for: "pivotShared" }
                  },
                  [_vm._v(_vm._s(_vm.$t("pivot.template.shareWithOwnAccount")))]
                )
              ]),
              _vm._v(" "),
              _vm.shared
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        { attrs: { for: "pivotSharedWithAccounts" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pivot.template.shareWithSubAccounts")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("vSelect", {
                        attrs: {
                          id: "pivotSharedWithAccounts",
                          options: _vm.accountsAvailableToShareWith,
                          reduce: e => e.dbId,
                          label: "text",
                          multiple: ""
                        },
                        model: {
                          value: _vm.sharedWithAccounts,
                          callback: function($$v) {
                            _vm.sharedWithAccounts = $$v
                          },
                          expression: "sharedWithAccounts"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnCancel")) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "createButton",
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: !_vm.name.length },
                  on: { click: _vm.createTemplate }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnCreate")) + "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }